// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_j0-0";
export var actionModalContentContainer = "_j0-1";
export var createTagButton = "_j0-2";
export var footerContainer = "_j0-7";
export var fullWidthDivider = "_j0-3";
export var hasCreateTagButton = "_j0-4";
export var noCreateTagButton = "_j0-5";
export var tagsContainer = "_j0-6";
export var tagsModalContentContainer = "_j0-8";